import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { requestSearchCustomer } from 'requests/customers'
import { EMPTY_CUSTOMER_INFO } from 'constants/objects/order'
import { SelectAutocomplete } from 'ui-components/SelectAutocomplete'
import { Container } from './styles'

export default function SelectCustomer(props) {
  const {
    onSelectCustomer,
    label,
    name,
  } = props

  const [searching, setSearching] = useState(false)
  const [selectOptions, setSelectOptions] = useState([])
  const [customers, setCustomers] = useState([])
  const [selectedCustomer, setSelectedCustomer] = useState({})

  let searchTimer = null

  const searchCustomer = async (value) => {
    setSearching(true)
    const { data } = await requestSearchCustomer(value)

    setSearching(false)
    if (!data?.length) return setCustomers([])

    const options = data.map((customer) => {
      const { name: customerName, document1 } = customer.attributes
      const doc = document1 ? ` - ${document1}` : ''

      return {
        id: customer.id,
        name: `${customerName}${doc}`,
      }
    })

    setSelectOptions(options)
    return setCustomers(data)
  }

  const handleAutocomplete = (evt) => {
    const { value } = evt.target
    if (!value) {
      setSelectOptions([])
      setCustomers([])
      return
    }

    if (value.length < 4) return

    clearTimeout(searchTimer)
    searchTimer = setTimeout(() => {
      searchCustomer(value)
    }, 600)
  }

  const handleCustomerSelect = (selected) => {
    let info = EMPTY_CUSTOMER_INFO
    let id = ''

    setSelectedCustomer(selected)
    if (selected) {
      const customer = customers.find((item) => item.id === selected.id)

      const {
        name: customerName,
        document1,
        email,
        description,
      } = customer?.attributes

      id = customer.id
      info = {
        name: customerName,
        document1,
        email,
        description,
      }
    }

    onSelectCustomer({
      customer_info: info,
      customer_id: id,
    })
  }

  return (
    <Container>
      <SelectAutocomplete
        label={label}
        name={name}
        options={selectOptions}
        onChange={handleAutocomplete}
        loading={searching}
        onSelect={handleCustomerSelect}
        noOptionsText={customers.length ? 'Registro não encontrado' : 'Digite nome ou documento'}
        selected={selectedCustomer}
      />
    </Container>
  )
}

SelectCustomer.propTypes = {
  onSelectCustomer: PropTypes.func.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
}

SelectCustomer.defaultProps = {
  label: 'Cliente',
  name: 'customer',
}
